/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "lazysizes";
import "typeface-lato";
import "typeface-raleway";
import "typeface-caveat";


require("prismjs/themes/prism-tomorrow.css")